import { render } from "./CheckoutAreaDesign.vue?vue&type=template&id=3c5c02af&scoped=true"
import script from "./CheckoutAreaDesign.vue?vue&type=script&lang=js"
export * from "./CheckoutAreaDesign.vue?vue&type=script&lang=js"

import "./CheckoutAreaDesign.vue?vue&type=style&index=0&id=3c5c02af&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5c02af"]])

export default __exports__